import { useTranslation } from 'react-i18next';

const colorMap: Record<string, { bg: string; text: string; light: string }> = {
  sky: { bg: 'bg-sky-600', text: 'text-sky-600', light: 'bg-sky-50' },
  emerald: { bg: 'bg-emerald-500', text: 'text-emerald-600', light: 'bg-emerald-50' },
  amber: { bg: 'bg-amber-500', text: 'text-amber-600', light: 'bg-amber-50' },
};

const benefits = [
  { icon: 'ri-heart-pulse-line', titleKey: 'ben1_title', descKey: 'ben1_desc', stat: '99.9%', statLabelKey: 'ben1_stat_label', color: 'sky' },
  { icon: 'ri-leaf-line', titleKey: 'ben2_title', descKey: 'ben2_desc', stat: '40%', statLabelKey: 'ben2_stat_label', color: 'emerald' },
  { icon: 'ri-home-smile-2-line', titleKey: 'ben3_title', descKey: 'ben3_desc', stat: '15%', statLabelKey: 'ben3_stat_label', color: 'amber' },
  { icon: 'ri-shield-star-line', titleKey: 'ben4_title', descKey: 'ben4_desc', stat: '100%', statLabelKey: 'ben4_stat_label', color: 'sky' },
];

export default function BenefitsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('ben_tag')}</span>
            <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 leading-tight">
              {t('ben_title1')}<br />{t('ben_title2')}
            </h2>
          </div>
          <p className="text-slate-500 text-base max-w-sm leading-relaxed">
            {t('ben_desc')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => {
            const colors = colorMap[benefit.color] || colorMap.sky;
            return (
              <div
                key={benefit.titleKey}
                className="bg-white rounded-2xl p-7 border border-slate-100 hover:border-sky-100 transition-all duration-300 flex flex-col"
              >
                <div className={`w-12 h-12 ${colors.light} rounded-xl flex items-center justify-center mb-5 shrink-0`}>
                  <i className={`${benefit.icon} ${colors.text} text-2xl`}></i>
                </div>
                <div className={`text-3xl font-black ${colors.text} mb-1`}>{benefit.stat}</div>
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wide mb-4">{t(benefit.statLabelKey)}</div>
                <h3 className="text-lg font-bold text-slate-800 mb-3">{t(benefit.titleKey)}</h3>
                <p className="text-slate-500 text-sm leading-relaxed flex-1">{t(benefit.descKey)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
